import {
    ROUTE_CHANGE_FORM,
    ROUTE_GO_TO_END_PAGE,
    MODAL_OVERLAY,
    SET_SHOW_API_PANEL,
    SET_LAST_VISITED_PAGE,

} from '@/lib/constants/mutations';

import {
    STEP_ROUTE_TYPE,
    END_PAGE_ROUTE_TYPE,
    STEP_LIMITER,
    END_PAGE_LIMITER,
    HASH,
} from '@/lib/constants/routes';
import {
    PORD_DOMAIN,
    DEV_DOMAIN
} from "@/forms/constants/onboarding-logic";
import getQueryVariable from '../helpers/get-query-variable';
import store from '@/store';
const changeTitle = (title) => {
    const { productType } = store.state;
    var newTitle = '';
    if (productType) {
        if (productType === 'Personal_Loan') {
            newTitle = 'Deem | Loan Application'; //onboarding;
        }
        if (productType === 'Credit Card') {
            newTitle = 'Deem | Credit Card Application';
        }
    } else {
        newTitle = `${title}`
    }
    document.title = newTitle;
};

const moveHistoryToForm = (formPath) => {
    const formUrl = formPath;
    window.history.pushState({}, '', formUrl + window.location.search);
};

const changeLocationTo = (stepName) => {
    window.location.assign(`${HASH}${STEP_LIMITER}${stepName}`);
};

const changeLocationToEndPage = (pageName) => {
    window.location.assign(`${HASH}${END_PAGE_LIMITER}${pageName}`);
};

const shouldShowApiPanel = (store) => {
    const showApiPanel = (getQueryVariable('show-api-panel') === 'true');
    store.commit(SET_SHOW_API_PANEL, { showApiPanel });
};


const onHashChange = routeManager => () => {
    const locationHash = window.location.hash;
    const { isOnEndPage } = routeManager;

    const newStepName = locationHash.split(STEP_LIMITER)[1];

    if (!newStepName) {
        return false;
    }

    if (isOnEndPage && routeManager.__forceRefreshOnStep) {
        window.location.reload();

        return false;
    }

    // ToDo: we now have get currentStepName in flow manager
    const currentStepName = routeManager.__flowManager.currentStep.name;

    if (currentStepName !== newStepName) {
        const moved = routeManager.__flowManager.goToStep(newStepName);

        if (!moved) {
            changeLocationTo(currentStepName);

            return false;
        }
    }

    return true;
};

const onStepChange = routeManager => () => {
    if (routeManager.isOnModal) {
        routeManager.hideModalOverlay();
    }
    if (routeManager.isOnStep && routeManager.__flowManager.currentStep) {
        changeLocationTo(routeManager.__flowManager.currentStep.name);
    }
};

const onFormChange = routeManager => () => {
    changeTitle(routeManager.currentFormName);
};

class RouteManager {
    constructor({ store, routes, flowManager }) {
        this.__routes = routes;
        this.__store = store;
        this.__setLastVisitedPage();

        this.__forceRefreshOnStep = false;
        this.__loadedForm = false;

        this.__flowManager = flowManager;

        this.__setupListeners();
        this.__setInitialForm();
    }

    __setInitialForm() {
        const pathName = window.location.pathname;
        const main = this.__routes.find(r => r.path === pathName);

        if (main && main.name) {
            var path = window.location.href;
            shouldShowApiPanel(this.__store);
            //Code added to restric refreshing page from executive referal
            // if (main.name === 'Deem | Sales Credit Card' || main.name === 'Deem | Sales Loan') {
            //   if (store.state.employeeCodes) {
            //     this.goToFormByName(main.name);
            //   }
            //   else {

            //     this.goToFormByName('Deem | Executive Referal');
            //   }
            // }
            if (main.name === 'Deem | Credit Card' && path.toUpperCase().includes('DSA')) {
                this.goToFormByName('404');
            } else if (main.name === 'Deem | Insurance Application') {
                this.goToFormByName('Deem | Protect');
            } else if (main.name === 'Deem | Credit Card Application' || main.name === 'Deem | Loan Application') {
                if (store.state.source || store.state.employeeCodes) {
                    this.goToFormByName(main.name);
                } else {
                    window.location.href = 'https://deem.io/';
                }
                //
                //|| main.name === 'Deem | STP Loan'//|| main.name === 'STP Loan'
            } else if (main.name === 'STP Card' || main.name === 'Deem | STP Card' || main.name === 'Deem | STP Loan' || main.name === 'STP Loan' || main.name === 'STP Top Up' ||
                main.name === 'Deem | STP Top Up') {
                if (store.state.employeeCodes) {
                    this.goToFormByName(main.name);
                } else {
                    this.goToFormByName('Deem | Stp Sales');
                    //window.location.href = 'https://apply.deem.io/stp/sales/';
                }
            } else if (main.name === 'STP Auto Loan' || main.name === 'Deem | NBC Auto Loan') {
                if (store.state.employeeCodes) {
                    this.goToFormByName(main.name);
                } else {
                    this.goToFormByName('Deem | Auto Sales');
                    //window.location.href = 'https://apply.deem.io/stp/sales/';
                }
            } else {
                this.goToFormByName(main.name);
            }

        } else {
            //console.log('last else block');
            this.goToFormByName('404');
        }
    }

    __setupListeners() {
        window.addEventListener('hashchange', onHashChange(this), false);
        this.__store.watch(
            state => state.formData.currentStepName,
            onStepChange(this),
        );
        this.__store.watch(
            state => state.formData.routing.formName,
            onFormChange(this),
        );
    }

    __setLastVisitedPage() {
        this.__store.commit(SET_LAST_VISITED_PAGE, {
            lastVisitedPage: document.referrer,
        });
    }

    get __routingState() {
            return this.__store.state.formData.routing;
        }
        //
    get isOnStep() {
        const { modalOverlay } = this.__store.state;
        if (modalOverlay) return true;
        return this.__routingState.type === STEP_ROUTE_TYPE;
    }

    get isOnEndPage() {
        const { modalOverlay } = this.__store.state;
        if (modalOverlay) return false;
        return this.__routingState.type === END_PAGE_ROUTE_TYPE;
    }

    get isOnModal() {
        const { modalOverlay } = this.__store.state;
        return modalOverlay;
    }

    get currentFormComponent() {
        return this.__routes.find(r => r.name === this.currentFormName).component;
    }

    get ready() {
        return !!this.currentFormName;
    }

    get currentFormName() {
        return this.__routingState.formName;
    }

    get lastVisitedPage() {
        return this.__store.state.lastVisitedPage;
    }

    goToFormByName(formName, { stepNameToInit } = {}) {
        if (formName !== this.currentFormName) {
            this.__flowManager.stop();
            this.__store.commit(ROUTE_CHANGE_FORM, { formName });
            const formRoute = this.__routes.find(r => r.name === formName);
            this.__loadedForm = false;

            if (stepNameToInit) {
                this.__stepNameToInit = stepNameToInit;
            }

            moveHistoryToForm(formRoute.path);
            this.hideModalOverlay();
        }

        return false;
    }

    loadedForm() {
        this.__loadedForm = true;
        this.__flowManager.init({ stepNameToInit: this.__stepNameToInit });

        this.__stepNameToInit = null;
    }

    goToEndPage(pageName, { stopGoBack }) {
        if (stopGoBack) {
            this.__flowManager.stop();
            this.__forceRefreshOnStep = true;
        }

        this.__store.commit(ROUTE_GO_TO_END_PAGE);
        this.hideModalOverlay();
        changeLocationToEndPage(pageName);
    }

    showModalOverlay() {
        this.__store.commit(MODAL_OVERLAY, { display: true });
    }

    hideModalOverlay() {
        this.__store.commit(MODAL_OVERLAY, { display: false });
    }

    goToLastVisitedPage() {
        const goToUrl = this.lastVisitedPage || process.env.VUE_APP_WEBSITE_URL;

        window.location.href = goToUrl;
    }
}

export default RouteManager;